<template>
  <div id="page">
    <el-container>
      <el-main>
        <router-view/>
      </el-main>
    </el-container>
  </div>
</template>

<script>

export default {
  name: 'HOME',
  data () {
    return {
      headerHeight: 60,
      pageKey: 1
    }
  },
  created () {
    this.handleResize()
  },
  methods: {
    handleResize () {
      const fullWidth = document.documentElement.clientWidth
      if (fullWidth > 788) {
        this.headerHeight = 60
      } else {
        this.headerHeight = 60
      }
    }
  }
}
</script>

<style lang="less">
.el-container {
  padding: 0 0 0 0;
}

.el-header {
  padding: 0 !important;
}

.el-main {
  padding: 0 !important;
}

.el-footer {
  padding: 0 !important;
}
</style>
